import { render, staticRenderFns } from "./InstructionsView.vue?vue&type=template&id=10f18be4&scoped=true&"
import script from "./InstructionsView.vue?vue&type=script&lang=js&"
export * from "./InstructionsView.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsView.vue?vue&type=style&index=0&id=10f18be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f18be4",
  null
  
)

export default component.exports